module.exports = __webpack_public_path__ + "static/media/telegram.49aafe51.svg";